import { render, staticRenderFns } from "./ListTransmision.vue?vue&type=template&id=21c5fcd9&"
import script from "./ListTransmision.vue?vue&type=script&lang=js&"
export * from "./ListTransmision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports